import { useContext, useState } from 'react'
import { LuMoreVertical } from 'react-icons/lu'
import { Button, Popover, Popconfirm } from 'antd'
import Context from 'containers/UMS/Users/Context'
// helpers
import dayjs from 'dayjs'
import get from 'lodash/get'
import isNan from 'lodash/isNaN'
import forEach from 'lodash/forEach'
import toNumber from 'lodash/toNumber'
import { isBefore, addYears } from 'date-fns'

const allTransactionsTypes = ["earn", "redeem", "refund", "expire"]

const getExpirationDate = (pointsRaw, transactions, transactionsTypes = allTransactionsTypes) => {
  const points = toNumber(pointsRaw)
  let date = null

  if (isNan(points) || points <= 0) return 'N/A'

  forEach(transactionsTypes, (type) => {
    const dateToCompare = get(transactions, `${type}.created_dt`, null)
    if (!!dateToCompare) {
      if (date === null || isBefore(date, dateToCompare)) date = dateToCompare
    }
  })

  if (date === null) return 'N/A'

  return dayjs(addYears(date, 1)).locale('es').format('DD MMM YYYY')
}

const Cell: React.FC<{ record: any }> = ({ record }) => {
  const { lastTransactionSummary, identity_point_count } = record

  const style = { display: 'flex', alignItems: 'center', justifyContent: 'start' }

  const props = {
    container: {
      style,
    }
  }

  const date = getExpirationDate(identity_point_count, lastTransactionSummary)

  return (
    <div {...props.container}>
      <div style={style}>
        {date}
      </div>
    </div>
  )
}

const ExpirationDate: React.FC = (id: string, record) => {
  if (id === '' || !id) return null

  return <Cell record={record} />
}

export default ExpirationDate
